import { createReducer } from '@reduxjs/toolkit';
import { updateFieldInteraction } from './actions';
import { userInteractionInitialState } from './state';

export const userInteractionReducer = createReducer(userInteractionInitialState, (builder) => {
  builder.addCase(updateFieldInteraction, (state, { payload }) => {
    if (!(payload in state)) {
      return state;
    }

    return { ...state, [payload]: { ...state[payload], isChanged: true } };
  });
});
